// src/components/ambassadors/BackgroundGlows.tsx

import { motion, MotionValue } from "framer-motion";

interface Props {
  goldX: MotionValue<string>;
  goldY: MotionValue<string>;
  roseX: MotionValue<string>;
  roseY: MotionValue<string>;
  blueX: MotionValue<string>;
  blueY: MotionValue<string>;
  isMobile: boolean;
}

export function BackgroundGlows({ goldX, goldY, roseX, roseY, blueX, blueY, isMobile }: Props) {
  if (isMobile) {
    return (
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-[10%] left-[-5%] w-[50vw] h-[50vw] bg-amber-500/10 rounded-full blur-[50px]" />
        <div className="absolute top-[20%] right-[-5%] w-[50vw] h-[50vw] bg-rose-500/10 rounded-full blur-[50px]" />
        <div className="absolute bottom-[5%] left-[20%] w-[60vw] h-[60vw] bg-blue-500/10 rounded-full blur-[50px]" />
      </div>
    );
  }

  return (
    <div className="absolute inset-0 pointer-events-none">
      <motion.div
        style={{ x: goldX, y: goldY }}
        className="absolute top-[8%] left-[-5%] w-[35vw] h-[35vw] bg-amber-500/10 rounded-full blur-[120px]"
      />
      <motion.div
        style={{ x: roseX, y: roseY }}
        className="absolute top-[15%] right-[-5%] w-[35vw] h-[35vw] bg-rose-500/10 rounded-full blur-[120px]"
      />
      <motion.div
        style={{ x: blueX, y: blueY }}
        className="absolute bottom-[0%] left-[20%] w-[40vw] h-[40vw] bg-blue-500/10 rounded-full blur-[120px]"
      />
    </div>
  );
}
